import { ImageType } from "./imageType";
export interface Organisation {
    _id: string;
    _organisationType: OrganisationTypeEnum
    organisationName?: string
    city?: string
    country?: string
    logo?: ImageType
    banner?: ImageType
    createAt?: Date
}

export enum OrganisationTypeEnum {
    Restaurant = 'Restaurant',
    Shop = 'Shop'
}